import store from 'src/store'

export default (_e: any, schema: { id: string; title: string }) => {
  const found = store.binder.findSchemaById(schema.id)
  found?.update('title', schema.title)
}
